// System imports
import 'regenerator-runtime'; // This appears to be needed for vue-apollo

import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import 'moment/locale/nl-be';
import capitalize from 'lodash/capitalize';
import * as VueDeepSet from 'vue-deepset'



import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createProvider } from './vue-apollo'

// Local imports
import format_duration from '@/lib/format_duration';
import format_moment from '@/lib/format_moment';
import format_money from '@/lib/format_money';
import format_indexation from '@/lib/format_indexation';
import format_toolate from '@/lib/format_toolate';
import '@mdi/font/css/materialdesignicons.min.css';

Vue.use(VueApexCharts);
Vue.use(VueDeepSet);

Vue.component('apexchart', VueApexCharts);

Vue.config.productionTip = false;


Vue.filter('format_money', format_money);
Vue.filter('format_moment', format_moment);
Vue.filter('format_duration', format_duration);
Vue.filter('format_indexation', format_indexation);
Vue.filter('format_toolate', format_toolate);
Vue.filter('capitalize', capitalize);

import * as VueGoogleMaps from 'vue2-google-maps'
import {M_LOGIN, M_SET_SUBTITLE, M_SET_TITLE, M_UPDATE_NOW, NETWORK_ONLY} from '@/lib/constants';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDH1QrYnVLvZ8byHBnCVxQt-qNcYqikDzU',
    // libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
})

const location = window.location;

let wsEndpoint = '';

if(location.protocol === 'https:')
    wsEndpoint += 'wss://';
else
    wsEndpoint += 'ws://';

wsEndpoint += `${location.host}${process.env.VUE_APP_GRAPHQL_WS_REL}?v=${APP_VERSION}`;

const apolloOpts =
{
    httpEndpoint: `${location.protocol}//${location.host}${process.env.VUE_APP_GRAPHQL_HTTP_REL}?v=${APP_VERSION}`,
    wsEndpoint
};

setInterval(() => store.commit(M_UPDATE_NOW), 60000);

const apolloProvider = createProvider(apolloOpts);


router.beforeEach(
    (to, from, next) =>
    {
        if(to.path !== from.path)
        {
            store.commit(M_SET_TITLE, to.meta?.title);
            store.commit(M_SET_SUBTITLE, '');
        }
        
        if(to.matched.some(record => record.meta.requiresAuth))
        {
            if (store.state.loggedIn)
                next();
            else
                next({ path: '/login', query: { redirect: to.fullPath }});
        }
        else
        {
            next();
        }
    }
);

async function start()
{
    try
    {
        const { data } = await apolloProvider.defaultClient.query(
            {
                query: require('./graphql/query/checkSession.gql'),
                fetchPolicy: NETWORK_ONLY
            }
        );

        if(data.checkSession.valid)
            store.commit(M_LOGIN, {username: data.checkSession.user.email});
    }
    catch (e)
    {
        console.error(e);
    }

    const v = new Vue(
        {
            router,
            store,
            apolloProvider,
            render: h => h(App)
        }
    ).$mount('#app');


}

start().then();